import axios from "axios";
import {
  API_BASE_URL,
  API_END_POINTS,
  ROUTES,
  SYSTEM_TOKEN,
} from "./constants";
import { getData } from "./storage";
import { logout, logoutSuccess } from "../slices/user";

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  config => {
    const userToken = getData('userToken')
    if (userToken) {
      config.headers['Authorization'] = userToken
    } else {
      config.headers['Authorization'] = SYSTEM_TOKEN
    }
    return config
  },
  error => Promise.reject(error)
)

export const SetupInterceptors = (store, navigate) => {
  axiosInstance.interceptors.request.use(
    (request) => {
      if (request.method === "delete") {
        request.headers["X-Destroy"] = "true";
      }
      if (
        request.url.includes(API_END_POINTS.LOGIN) ||
        request.url.includes(API_END_POINTS.SIGNUP) ||
        request.url.includes(API_END_POINTS.MFA) ||
        request.url.includes(API_END_POINTS.FORGOTPASSWORD)
      ) {
        request.headers["Authorization"] = SYSTEM_TOKEN;
      } else {
        const userToken = getData("userToken");
        if (userToken) {
          request.headers["Authorization"] = userToken;
        }
      }

      return request;
    },
    (config) => {
      return config;
    },
    (error) => Promise.reject(error)
  );

  axiosInstance.interceptors.response.use(
    (res) => {
      return res;
    },
    async (err) => {
      const originalConfig = err.config;
      if (err.response) {
        if (err.response.status === 401 && !originalConfig._retry) {
          store.dispatch(logoutSuccess());
          return Promise.reject(err);
        }
        if (err.response.status === 403 && err.response.data) {
          return Promise.reject(err);
        }
      }
      return Promise.reject(err);
    }
  );
};

export default axiosInstance;
